import { atom } from 'recoil';

export const companyAtom = atom({
  key: 'companyAtom',
  default: {
    loading: false,
    item: null,
    items: [],
    error: null
  },
});